export const reportsDataDefault = {
  registeredCount: [
    {
      Bacia: "Baixo Jaguaribe",
      Quantidade: 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Quantidade: 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Quantidade: 0,
    },
  ],
  captationCount: [
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Janeiro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Janeiro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Fevereiro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Fevereiro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Março",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Março",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Abril",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Abril",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Maio",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Maio",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Junho",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Junho",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Julho",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Julho",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Agosto",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Agosto",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Setembro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Setembro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Outubro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Outubro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Novembro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Novembro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Dezembro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Mes: "Dezembro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Janeiro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Janeiro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Fevereiro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Fevereiro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Março",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Março",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Abril",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Abril",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Maio",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Maio",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Junho",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Junho",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Julho",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Julho",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Agosto",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Agosto",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Setembro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Setembro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Outubro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Outubro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Novembro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Novembro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Dezembro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Mes: "Dezembro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Janeiro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Janeiro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Fevereiro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Fevereiro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Março",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Março",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Abril",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Abril",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Maio",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Maio",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Junho",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Junho",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Julho",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Julho",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Agosto",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Agosto",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Setembro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Setembro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Outubro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Outubro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Novembro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Novembro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Dezembro",
      Captação: "Subterrânea",
      "Vazão média": 0,
      "Volume médio": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Mes: "Dezembro",
      Captação: "Superficial",
      "Vazão média": 0,
      "Volume médio": 0,
    },
  ],
  workersCount: [
    {
      Bacia: "Alto Jaguaribe",
      Tipo: "Pessoa Física",
      "Média de trabalhadores": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Tipo: "Pessoa Jurídica",
      "Média de trabalhadores": 0,
    },
    {
      Bacia: "Médio Jaguaribe",
      Tipo: "Pessoa Física",
      "Média de trabalhadores": 0,
    },
    {
      Bacia: "Alto Jaguaribe",
      Tipo: "Pessoa Jurídica",
      "Média de trabalhadores": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Tipo: "Pessoa Física",
      "Média de trabalhadores": 0,
    },
    {
      Bacia: "Baixo Jaguaribe",
      Tipo: "Pessoa Jurídica",
      "Média de trabalhadores": 0,
    },
  ],
  aquaculture: [],
  tankCaptation: [],
  securityWater: [],
  securitySocial: [],
  securityEconomic: [],
  securityProductive: [],
  hydricResources: [],
};

export const mockedHydricResources = {
  "Alto Jaguaribe": [
    {
      Cultura: "ABACATE",
      CorteHidrico: 11,
    },
    {
      Cultura: "AÇAI",
      CorteHidrico: 18,
    },
    {
      Cultura: "ACEROLA",
      CorteHidrico: 28,
    },
    {
      Cultura: "ARROZ",
      CorteHidrico: 57,
    },
    {
      Cultura: "ATA",
      CorteHidrico: 24,
    },
    {
      Cultura: "CAJU",
      CorteHidrico: 30,
    },
  ],
  "Baixo Jaguaribe": [
    {
      Cultura: "ABACATE",
      CorteHidrico: 2128,
    },
    {
      Cultura: "AÇAI",
      CorteHidrico: 3080,
    },
    {
      Cultura: "ACEROLA",
      CorteHidrico: 257,
    },
    {
      Cultura: "ARROZ",
      CorteHidrico: 1160,
    },
    {
      Cultura: "ATA",
      CorteHidrico: 454,
    },
    {
      Cultura: "CAJU",
      CorteHidrico: 0,
    },
  ],
  "Médio Jaguaribe": [
    {
      Cultura: "ABACATE",
      CorteHidrico: 9199,
    },
    {
      Cultura: "AÇAI",
      CorteHidrico: 9273,
    },
    {
      Cultura: "ACEROLA",
      CorteHidrico: 339,
    },
    {
      Cultura: "ACEROLA",
      CorteHidrico: 1393,
    },
    {
      Cultura: "ARROZ",
      CorteHidrico: 1818,
    },
    {
      Cultura: "ATA",
      CorteHidrico: 1082,
    },
    {
      Cultura: "CAJU",
      CorteHidrico: 0,
    },
  ],
};

export const reportsDataAllDefault = {
  hydricResources: null,
};
